import React from 'react';
import CardBalanceDepositar from '../../../card/CardBalanceDepositar'

import Col from '../../../../assets/currency/copu.png'
import Usd from '../../../../assets/currency/usd.png'

import Bank from '../../../../assets/IconsColurs/IconsGeneral/bank.svg'
import PSE from '../../../../assets/img/depositar/PSE.png'
import Colurs from '../../../../assets/img/depositar/icon.png'
import USDT from '../../../../assets/img/depositar/usdt.png'


const SelectBuyColurs = ({

    balanceBanck = 'Consigna directamente a nuestra cuenta bancaria',
    balancePSE = 'Ingresa tus datos personales y paga usando el portal PSE',
    balanceColurs = 'Recibe saldo en tu wallet usando tu código QR',
    balanceUSDT = "Recarga tus USD con activos digitales de otras wallets",

    labelBanck = "Transferencia Bancaria",
    labelPSE = "PSE (Recomendado)",
    labelUsd = "USDT / USDC",
    labelColurs = "Saldo Colurs",

    TransfertBanck,
    TransfertUsdt,
    TransfertColurs,
    TransfertPSE,
    walletCop

}) => {

    return (
        <>
            {walletCop && < p className='w-full flex mt-4 text-base font-normal text-[#B7B7B9] traking-[-0.14px] leading-5 ' >Compra Saldo Colurs (COP) usando cualquiera de estos medios:</p >}
            {!walletCop && < p className='w-full flex mt-4 text-base font-normal text-[#B7B7B9] traking-[-0.14px] leading-5 ' >Compra Dólares Estadounidenses usando cualquiera de estos medios:</p >}
            <div className='w-full h-full flex items-center gap-2 justify-center py-4  ' >
                {walletCop && <>
                    <CardBalanceDepositar icon={Bank} balance={balanceBanck} hover={true} textBalance={'text-[14px]'} label={labelBanck} onClick={TransfertBanck} />
                    <CardBalanceDepositar icon={PSE} balance={balancePSE} hover={true} textBalance={'text-[14px]'} label={labelPSE} onClick={TransfertPSE} />
                    {/*                     <CardBalanceDepositar icon={Colurs} balance={balanceColurs} hover={true} textBalance={'text-[14px]'} label={labelColurs} onClick={TransfertColurs} />
 */}                </>}

                {!walletCop && <>
                    <CardBalanceDepositar icon={Bank} balance={balanceBanck} hover={true} textBalance={'text-[14px]'} label={labelBanck} onClick={TransfertBanck} />
                    <CardBalanceDepositar icon={USDT} balance={balanceUSDT} hover={true} textBalance={'text-[14px]'} label={labelUsd} onClick={TransfertUsdt} />
                    {/*                     <CardBalanceDepositar icon={Colurs} balance={balanceColurs} hover={true} textBalance={'text-[14px]'} label={labelColurs} onClick={TransfertColurs} />
 */}                </>}
            </div>
        </>
    );
};

export default SelectBuyColurs;
